const unicodeRegexGreedy = /[^\p{L}\p{N}_\-\s]+?/gu;
const unicodeRegex = /[^\p{L}\p{N}_\-\s]+/gu;

export const normalizeTranslationKey = (text) => {
    const s = String(text ?? '');
    return typeof s.replaceAll === 'function'
        ? s.replaceAll(unicodeRegexGreedy, '__')
        : s.replace(unicodeRegex, '__'); // while no replaceAll is available, we use a regex to replace all non-alphanumeric characters with underscores
};
